import ACLStore from "lib/aclStore";

export const getShowSprinklrChat = ({ userType }) => {
  switch (userType) {
    case "staff":
      return ACLStore.can("FeatureFlag:EnableSprinkalrChatSupport");
    case "student":
      return ACLStore.can("FeatureFlag:EnableSprinklrChatSupportStudent");
    case "parent":
      return ACLStore.can("FeatureFlag:EnableSprinklrChatSupportParent");
    default:
      return false;
  }
};
